<template>
    <div class="printOptionsComponent">
        <div class="formatContainer container">
            <div class="subcontainer">
                <div v-for="print_option in label.print_options" v-if="print_option.code !='p_quantity' &&((print_option.code!='book_binding' && type == 'all') ||
                (print_option.code=='book_binding' && type == 'book_binding'))" v-show="parseInt(print_option.options.length) > 1">
                    <h4 class="h5">{{print_option.name}}</h4>
                    <div class="optionHolder"  >
                        <div v-for="option in print_option.options" :class="[{active: parseInt(option.isActive),optionPlaceholderColor:(print_option.code=='colors' ||print_option.code=='book_binding' ), dog_color:parseInt(option.is_dog_tag),dont_show_image:(option.image_url =='')},'optionPlaceHolder','cmpt','page_option'+option.code+'_'+option.product_part ,print_option.code]" @click="changeConfiguration($event,option)">
                            <a v-if="print_option.code!='colors' && print_option.code!='book_binding'" href="javascript:void(0)">{{option.name}}</a>
                            <a v-if="print_option.code=='book_binding'" href="javascript:void(0)">
                                <img v-if="option.image_url!=''" :src="option.image_url" alt="image description" width="101" height="92">
                                <strong>{{option.name}}</strong>
                            </a>
                            <a v-if="print_option.code=='colors'" href="javascript:void(0)">
                                <img v-if="option.image_url!=''" :src="option.image_url" alt="image description" width="101" height="92">
                                <span v-if="typeof(option.palette_colors[0]) !='undefined'" class="default_color"  :style="[{  'background-color' : 'rgb('+label.defaultEditorColors[option.palette_colors[0]].rgb+')'}]"></span>
                                <strong v-if="!parseInt(option.is_dog_tag)">{{option.name}}</strong>
                                <ul class="pallete_colors" v-if="(option.parent == 'colors' && option['palette_colors'].length && !parseInt(option.is_dog_tag))">
                                <li v-if="(typeof(label.defaultEditorColors[palette_color]) != 'undefined' )" v-for="palette_color in option.palette_colors" >
                                    <span class="color" :style="[{  'background-color' : 'rgb('+label.defaultEditorColors[palette_color].rgb+')'}]"></span>
                                    <span class="number" v-if="(typeof(option['pallete_numbers'][palette_color]) != 'undefined' )">{{option['pallete_numbers'][palette_color]}}</span>
                                </li>
                            </ul>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props   : ['label','type'],
        methods : {
            changeConfiguration (event, option ) {
                var target = $jQuery(event.target);
                 let  ok = 0;
                 if(target.hasClass('disabledOption')){
                     ok=1;
                 }
                if(!target.hasClass('shouldNotPassChanges')) {
                    $jQuery.printqLabelEditor.passChanges( option.code, this.label.id, option.parent, option.product_part );
                    this.label.isReady = 0;
                }
                target.removeClass( 'shouldNotPassChanges' );

                store.dispatch( 'setOptionActive', {labelId : this.label.id, option : option} );

                if ( option.parent == "colors" ) {
                    store.dispatch( 'changeBackgroundColor', {
                        record     : this.label,
                        backColorId : option.palette_colors[0]
                    } );
                }
                var oldLines = JSON.stringify( this.label.lines );
                var oldCliparts = JSON.stringify( this.label.cliparts_blocks );
                if ( option.parent == "format" ) {
                    this.label.default_format = option.code;
                    if(parseInt(this.label.use_icon) && parseInt(this.label.labelUseClipartItem && 0)){
                        var code= this.label.default_format;
                        if ( typeof(this.label.formats_icons) != "undefined" && typeof(this.label.formats_icons[code]) != "undefined") {
                            //   code = 'default_171';
                            this.label.lines = this._O( this.label.formats_icons[code].lines, this.label.lines );
                       //    this.label.lines = JSON.parse(JSON.stringify(this.label.formats[code].lines))  /*this._O( this.label.formats_icons[code].lines, this.label.lines )*/;
                            this.label.backgrounds = this._O( this.label.formats_icons[code].backgrounds, this.label.backgrounds );
                            this.label.cliparts_blocks = this._O( this.label.formats_icons[code].cliparts_blocks, this.label.cliparts_blocks );
                            this.label.back_images =  this.label.formats_icons[code].back_images, this.label.back_images ;
                            this.label.width = this.label.formats_icons[code].width
                            this.label.height = this.label.formats_icons[code].height;
                            this.label.code = this.label.formats_icons[code].code;
                            this.label.image = this.label.formats_icons[code].image;
                        }
                    }else{
                 //       var code= this.label.default_format;
                       var code= option.code;
                       console.log(code);
                        if ( typeof (this.label.formats[code]) != "undefined" ) {
                                //this.label.lines  = {};



                            if ( !([215, 162, 404, 420, 406, 407, 423, 407, 424].indexOf( (parseInt( product_id )) ) > -1) && 0) {
                                this.label.lines =JSON.parse( JSON.stringify( this.label.formats[code].lines ) );
                                JSON.parse( oldLines ).forEach( (function( instance ) {
                                    return function( elementOriginal, index ) {
                                        if ( typeof (instance.label.lines[index]) != "undefined" ) {
                                            instance.label.lines[index].text = elementOriginal.text;
                                        }
                                    }
                                })( this ) )
                            }else{
                                this.label.lines =  JSON.parse( JSON.stringify( this.label.formats[code].lines ) );

                            }

                            this.label.backgrounds = this._O( this.label.formats[code].backgrounds, this.label.backgrounds );
                            this.label.cliparts_blocks = this._O( this.label.formats[code].cliparts_blocks, this.label.cliparts_blocks );
                            this.label.back_images =  this.label.formats[code].back_images;
                            this.label.width = this.label.formats[code].width
                            this.label.height = this.label.formats[code].height;
                            this.label.code = this.label.formats[code].code;
                            this.label.image = this.label.formats[code].image;
                            this.label.templateid = this.label.formats[code].templateid;
                            this.label.code = this.label.formats[code].code;
                        }
                    }


                   store.dispatch( 'changeFormat', {
                            labelId    : this.label.id,
                            formatCode : this.label.formats[option.code]
                        } );


                    setTimeout((function(instance){
                        return function (){
                                 const x ={
                        record     : instance.label,
                        backColorId : instance.label.current_color
                    }
                              instance.$store.dispatch( 'changeBackgroundColor',x  );
                            instance.$store.dispatch( 'setMasterText', {labelId : instance.label.id} );
                    store.dispatch( 'initPage', {label : instance.label} );
                     $jQuery('.clipartItem.active').trigger('click');
                            if(typeof(oldLines)!="undefined") {
                                var l = []
                                JSON.parse( oldLines ).forEach( (function( instance ) {
                                    return function( elementOriginal, index ) {
                                        if ( !parseInt( elementOriginal.masterBlock ) && !parseInt( elementOriginal.master_type ) ) {
                                            l.push( elementOriginal['text'] );
                                        }
                                    }
                                })( instance ) );
                                var bigIndex = 0;
                                instance.label.lines.forEach( (function( instance ) {
                                    return function( elementOriginal, index ) {
                                        if ( !parseInt( elementOriginal.masterBlock )  ) {
                                            if ( typeof (l[bigIndex]) != "undefined" ) {
                                                instance.label.lines[index]['text'] = l[bigIndex];
                                                bigIndex++;
                                                var event;
                                                if ( typeof (Event) === 'function' ) {
                                                    event = new Event( 'updateLine' );
                                                }
                                                else {
                                                    event = document.createEvent( 'Event' );
                                                    event.initEvent( 'updateLine', true, true );

                                                }
                                                window.dispatchEvent( event )
                                            }
                                        }
                                    }
                                })( instance ) );
                            }
                            instance.$store.dispatch( 'setMasterText', {labelId : instance.label.id} );


                        }
                    })(this),400)

                }
            },
            _O: function (o,defaults) {
             //   var d = $jQuery.extend(true, {}, d);
                return $jQuery.extend(true, defaults, o);
            },
             goclone(source) {
                 if (Object.prototype.toString.call(source) === '[object Array]') {
                     var clone = [];
                     for (var i=0; i<source.length; i++) {
                         clone[i] = this.goclone(source[i]);
                     }
                     return clone;
                 } else if (typeof(source)=="object") {
                     var clone = {};
                     for (var prop in source) {
                         if (source.hasOwnProperty(prop)) {
                             clone[prop] = this.goclone(source[prop]);
                         }
                     }
                     return clone;
                 } else {
                     return source;
                 }
}
        },
        computed : {
            getOptionClass ( option ) {
                return  option.code;
            }
        }
    }
</script>
<style>
    .pallete_colors{
      margin: 0;
    list-style: none;
    display: flex;
    justify-content: center;
    padding: 5px 0 6px;
    align-items: center;
    float: left;
    flex-wrap: wrap;
    width: 100%;
    }

    .optionHolder .book_binding strong{
        padding:0px;
    }
    .pallete_colors li{
        display: block;
        width: auto;
        float:left;
        margin:0 2px;
        text-align: center;
    }

    .pallete_colors li span.number {
        color : #000000;
        clear : both;
        float : left;
        display: inline-block;
        width: 100%;
        font-size: 16px;
        font-weight: 500;
    }

    .pallete_colors li span.color {
        display       : inline-block;
        border        : 2px solid #FFFFFF;
        width         : 22px;
        height        : 22px;
        border-radius : 50%;
        clear         : both;
        float         : left;
        width         : 100%;
        min-width     : 22px;
        font-size: 1px;
    }


    .optionPlaceholderColor{
        height: auto;
    }

    .optionHolder {
        width : 100%;
            padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    margin: 0 -27px 14px 0;
        font-family     : 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-size       : 16px;
        font-weight     : 600;
        justify-content : center;

    }

    .optionHolder div {
        width  : calc(33.33% - 27px);
        margin : 0 27px 26px 0;
        float:left;
         display         : inline-flex;
    }
    .optionHolder div a{
            color: #ea8d00;
            border-radius: 10px;
    background: #f9f9f9;
    box-shadow: 0 3px 0 0 rgba(0, 0, 0, 0.14);
    padding: 11px 5px 4px;
    min-height: 50px;
    text-align: center;
    border: solid 2px #f9f9f9;
    display: block;
            color: #005380;
        width: 100%;
    }

    .optionHolder div.active{
        display:flex !important;
    }
    .optionHolder a:hover,
    .optionHolder div.active a
    {
            color: #ea8d00;
        background: #fff;
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.14);
        border: solid 2px #ea8d00;
        text-decoration: none !important;
    }
    .optionHolder img {
    display: block;
    margin: 0 auto;
    }
    .optionHolder strong{
        width: 100%;
        float: left;
        font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-size: 18px;
        font-weight: 600;
        display: block;
        padding: 2px 0 16px
    }

    .dog_color {
        width  : auto !important;;
        margin : 0 10px 20px 0 !important;;
    }
    .dog_color a {
    padding: 8px !important;
}
    .dog_color img {
    border: 2px solid #fff;
    border-radius: 100%;
    width: 42px;
    height: 42px;
        display : none;
    }

    .dog_color.dont_show_image .default_color {
        display : inline-block;
    }

    .default_color {
        width         : 42px;
        height        : 42px;
        border-radius : 50%;
        border        : 2px solid #FFFFFF;
        display       : none;
    }

    .dog_color .default_color,
    .dog_color.dont_show_image img
    {
        display:none;
    }

    .dog_color img{
        display:block;
    }
</style>



// WEBPACK FOOTER //
// src/components/Printoptions/Printoptions.vue